module.exports = __webpack_public_path__ + "static/media/logo-comune-paterno.9b455280.png";